import { cssVars } from '@/app/styles';
import { Charts } from '@/chart/chart';
import { LineChartOptions } from '@/chart/chart-options';
import { DEFAULT_CHART_BASE_TYPE } from '@/chart/components/all-charts-styles';
import { DisplayMinMaxValuePlugin } from '@/chart/plugins/display-min-max-value-plugin';
import { datasetTypes } from '@/constants';
import {
  MultiValueDataBuilder,
  constructDatasets,
} from '@/utils/chart-data-builder';
import { numberToPercent } from '@/utils/string-utils';

export class RentalSizeDataBuilder extends MultiValueDataBuilder {
  constructor(
    data,
    chartMode = null,
    dataType = 'rentalSize',
    extractionType = 'value'
  ) {
    super(data, dataType, extractionType);
    this.chartMode = chartMode;
    this.datasetConfigurations = RentalSizeDataBuilder.configurations;
  }

  static get configurations() {
    return [
      {
        fill: false,
        pointRadius: 2, // dot radius
        pointHoverRadius: 4, // dot radius on hover
        borderWidth: 2,
        borderColor: 'rgba(64, 169, 255, .8)',
        backgroundColor: 'rgba(64, 169, 255, .8)',
      },
      {
        fill: false,
        pointRadius: 2, // dot radius
        pointHoverRadius: 4, // dot radius on hover
        borderWidth: 2,
        borderColor: 'rgba(255, 122, 69, 0.8)',
        backgroundColor: 'rgba(255, 122, 69, 0.8)',
      },
      {
        fill: false,
        pointRadius: 2, // dot radius
        pointHoverRadius: 4, // dot radius on hover
        borderWidth: 2,
        borderColor: 'rgba(54, 207, 201, 0.8)',
        backgroundColor: 'rgba(54, 207, 201, 0.8)',
      },
      {
        fill: false,
        pointRadius: 2, // dot radius
        pointHoverRadius: 4, // dot radius on hover
        borderDash: [6, 5],
        borderWidth: 2,
        borderColor: 'rgba(149, 222, 100, 0.8)',
        backgroundColor: 'rgba(149, 222, 100, 0.8)',
      },
    ];
  }

  get retrieveDatasets() {
    return constructDatasets(
      this.labels,
      this.data,
      'line',
      this.datasetConfigurations
    );
  }
}

class RentalSizeChart extends Charts {
  static pluginParams = {
    pluginTextColor: cssVars.chartColors.RENTAL_SIZE,
    pluginFormatter: numberToPercent,
    pluginAlignment: 'top',
  };

  static tooltipParams = {
    unit: '',
  };

  static getParams() {
    return {
      pluginParams: this.pluginParams,
      tooltipParams: this.tooltipParams,
    };
  }

  static getOptions(props) {
    return {
      ...RentalSizeChart.getParams(),
      ...props,
    };
  }

  constructor(props) {
    super({
      DataBuilder: RentalSizeDataBuilder,
      chartProps: props,
      name: datasetTypes.RENTAL_SIZE,
      options: new LineChartOptions(RentalSizeChart.getOptions(props))
        .chartOptions,
      baseType: DEFAULT_CHART_BASE_TYPE,
      plugins: [DisplayMinMaxValuePlugin()],
    });
  }
}

const chart = (props) => new RentalSizeChart(props).chart;

export default chart;
